import React, { useEffect, useRef, useState } from 'react';
import { Linkedin, Facebook,Instagram, Phone, Mail, MapPin, Whatsapp, Youtube} from 'lucide-react';
import { FaXTwitter } from 'react-icons/fa6';
import { Link } from 'react-router-dom';
import idlbayLogo from '../assets/idl2.png';
import idlbayLogoColor from '../assets/idl1.png'
import char from '../assets/idlbaybot.png';
import colors from '../ColorConfig/colorconfig';
import GetInTouchForm from '../GetinTouchform/GetinTouch';
import './footer.css';
import { FaWhatsapp } from 'react-icons/fa';

const Footer = () => {
  const footerRef = useRef(null);
  const [isLogoHovered, setIsLogoHovered] = useState(false);
  const whatsappMessage = "Hello! I'm interested in your services. Could you please provide more information?";

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.2,
    };
    
    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('idlbayfooter-animate-in');
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);
    
    if (footerRef.current) {
      const sections = footerRef.current.querySelectorAll('.idlbayfooter-section');
      sections.forEach(section => {
        observer.observe(section);
      });
    }
    
    return () => observer.disconnect();
  }, []);

  // Function to handle phone call
  const handlePhoneClick = () => {
    window.location.href = 'tel:+919840841840';
  };

  // Function to handle email
  const handleEmailClick = () => {
    window.location.href = 'mailto:contact@idlbay.com';
  };

  // Function to handle WhatsApp
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/919840841840', '_blank');
  };

  return (
    <footer className="idlbayfooter-container" ref={footerRef} style={{ backgroundColor: colors.bodyBlack }}>
      <div className="idlbayfooter-content">
        <div className="container">
          {/* Desktop Layout - All sections in one row */}
          <div className="idlbayfooter-main-sections d-none d-md-flex">
            
           {/* Logo & Description Section */}
            <div className="idlbayfooter-section idlbayfooter-company-wrapper">
              <div className="idlbayfooter-company-section">
                <div className="idlbayfooter-brand-container">
                  <Link 
                    className="idlbayfooter-navbar-brand" 
                    to="/"
                    onMouseEnter={() => setIsLogoHovered(true)}
                    onMouseLeave={() => setIsLogoHovered(false)}
                  >
                    <img 
                      src={isLogoHovered ? idlbayLogoColor : idlbayLogo} 
                      alt="IDLBAY Logo" 
                      className="idlbayfooter-logo-img"
                      style={{transition: 'none'}}
                    />
                  </Link>
                </div>
                <h6 className="idlbayfooter-company-description">
                  Empowering Businesses with Next-Gen IT Solutions that drive innovation, 
                  efficiency, and sustainable growth in the digital era.
                </h6>
              </div>
            </div>

            {/* Character Image Section */}
            <div className="idlbayfooter-section idlbayfooter-character-wrapper">
              <div className="idlbayfooter-character-section">
                <img 
                  src={char}
                  alt="Character" 
                  className="idlbayfooter-character-img"
                />
              </div>
            </div>

            {/* Get In Touch Form Section */}
            <div className="idlbayfooter-section idlbayfooter-form-wrapper">
              <div className="idlbayfooter-form-section">
                <GetInTouchForm isFooterVersion={true} />
              </div>
            </div>

            {/* Quick Links */}
            <div className="idlbayfooter-section idlbayfooter-links-wrapper">
              <div className="idlbayfooter-links-section">
                <h5 className="idlbayfooter-section-title">Quick Links</h5>
                <ul className="idlbayfooter-link-list">
                  <li><Link to="/" className="idlbayfooter-footer-link">Home</Link></li>
                  <li><Link to="/about" className="idlbayfooter-footer-link">About Us</Link></li>
                  <li><Link to="/services" className="idlbayfooter-footer-link">Services</Link></li>
                  <li><Link to="/products" className="idlbayfooter-footer-link">Products</Link></li>
                  <li><Link to="/blog" className="idlbayfooter-footer-link">Blog</Link></li>
                </ul>
              </div>
            </div>

            {/* Company */}
            <div className="idlbayfooter-section idlbayfooter-companylinks-wrapper">
              <div className="idlbayfooter-links-section">
                <h5 className="idlbayfooter-section-title">Company</h5>
                <ul className="idlbayfooter-link-list">
                  <li><Link to="/contactus" className="idlbayfooter-footer-link">Contact Us</Link></li>
                </ul>
              </div>
            </div>

            {/* Contact Info */}
            <div className="idlbayfooter-section idlbayfooter-contact-wrapper">
              <div className="idlbayfooter-contact-section">
                <h5 className="idlbayfooter-section-title">Contact Info</h5>
                <div className="idlbayfooter-contact-items">
                  <div 
                    className="idlbayfooter-contact-item d-flex align-items-center"
                    onClick={handlePhoneClick}
                  >
                    <div className="idlbayfooter-contact-icon">
                      <Phone size={16} />
                    </div>
                    <div className="idlbayfooter-contact-details ms-2">
                      <span className="idlbayfooter-contact-value">
                        +91 9840 841 840
                      </span>
                    </div>
                  </div>
                  
                  <div 
                    className="idlbayfooter-contact-item d-flex align-items-center mt-2"
                    onClick={handleEmailClick}
                  >
                    <div className="idlbayfooter-contact-icon">
                      <Mail size={16} />
                    </div>
                    <div className="idlbayfooter-contact-details ms-2">
                      <span className="idlbayfooter-contact-value">
                        contact@idlbay.com
                      </span>
                    </div>
                  </div>
                </div>

                {/* Social Media Links */}
                <div className="idlbayfooter-social-links">
                  <a href="https://www.linkedin.com/company/idlbay" className="idlbayfooter-social-link" aria-label="LinkedIn">
                    <Linkedin size={18} />
                  </a>
                   <a href="https://www.instagram.com/idlbay.official/" className="idlbayfooter-social-link" aria-label="Instagram">
                    <Instagram size={18} />
                  </a>
                   {/* <a 
                    href={`https://wa.me/919840841840?text=${encodeURIComponent(whatsappMessage)}`}
                    className="idlbayfooter-social-link" 
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Contact us on WhatsApp"
                    onClick={handleWhatsAppClick}
                  >
                    <FaWhatsapp size={18} />
                  </a> */}
                    <a href="https://x.com/idlbayPvtLtd" className="idlbayfooter-social-link" aria-label="X (formerly Twitter)">
                      <FaXTwitter size={18} />
                    </a>
                  <a href="https://www.facebook.com/profile.php?id=61582746578911" className="idlbayfooter-social-link" aria-label="Facebook">
                    <Facebook size={18} />
                  </a>
                    <a href="https://www.youtube.com/channel/UCDSb9__-mSLqeyuZYelakcw" className="idlbayfooter-social-link" aria-label="Youtube">
                    <Youtube size={18} />
                  </a>
                 
                 
                 
                </div>
              </div>
            </div>
          </div>

          {/* Mobile Layout - Structured Rows */}
          <div className="d-block d-md-none">
            {/* Mobile Row 1: Company Section Only */}
            <div className="idlbayfooter-mobile-row-1">
              <div className="idlbayfooter-section idlbayfooter-company-wrapper">
                <div className="idlbayfooter-company-section">
                  <div className="idlbayfooter-brand-container">
                    <Link 
                      className="idlbayfooter-navbar-brand" 
                      to="/"
                      onMouseEnter={() => setIsLogoHovered(true)}
                      onMouseLeave={() => setIsLogoHovered(false)}
                    >
                      <img 
                        src={isLogoHovered ? idlbayLogoColor : idlbayLogo} 
                        alt="IDLBAY Logo" 
                        className="idlbayfooter-logo-img"
                        style={{transition: 'none'}}
                      />
                    </Link>
                  </div>
                  <p className="idlbayfooter-company-description">
                    Empowering Businesses with Next-Gen IT Solutions that drive innovation, 
                    efficiency, and sustainable growth in the digital era.
                  </p>
                </div>
              </div>
            </div>

            {/* Mobile Row 2: Character + Form Side by Side */}
            <div className="idlbayfooter-mobile-row-2">
              <div className="idlbayfooter-section idlbayfooter-character-wrapper">
                <div className="idlbayfooter-character-section">
                  <img 
                    src={char}
                    alt="Character" 
                    className="idlbayfooter-character-img"
                  />
                </div>
              </div>

              <div className="idlbayfooter-section idlbayfooter-form-wrapper">
                <div className="idlbayfooter-form-section">
                  <GetInTouchForm isFooterVersion={true} />
                </div>
              </div>
            </div>

            {/* Mobile Row 3: Quick Links + Company Links Side by Side */}
            <div className="idlbayfooter-mobile-row-3">
              <div className="idlbayfooter-section idlbayfooter-links-wrapper">
                <div className="idlbayfooter-links-section">
                  <h5 className="idlbayfooter-section-title">Quick Links</h5>
                  <ul className="idlbayfooter-link-list">
                    <li><Link to="/" className="idlbayfooter-footer-link">Home</Link></li>
                    <li><Link to="/about" className="idlbayfooter-footer-link">About Us</Link></li>
                    <li><Link to="/services" className="idlbayfooter-footer-link">Services</Link></li>
                    <li><Link to="/products" className="idlbayfooter-footer-link">Products</Link></li>
                    <li><Link to="/blog" className="idlbayfooter-footer-link">Blog</Link></li>
                  </ul>
                </div>
              </div>

              <div className="idlbayfooter-section idlbayfooter-companylinks-wrapper">
                <div className="idlbayfooter-links-section">
                  <h5 className="idlbayfooter-section-title">Company</h5>
                  <ul className="idlbayfooter-link-list">
                    <li><Link to="/contactus" className="idlbayfooter-footer-link">Contact Us</Link></li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Mobile Row 4: Contact Info Only */}
            <div className="idlbayfooter-mobile-row-4">
              <div className="idlbayfooter-section idlbayfooter-contact-wrapper">
                <div className="idlbayfooter-contact-section">
                  <h5 className="idlbayfooter-section-title">Contact Info</h5>
                  <div className="idlbayfooter-contact-items">
                    <div 
                      className="idlbayfooter-contact-item d-flex align-items-center"
                      onClick={handlePhoneClick}
                    >
                      <div className="idlbayfooter-contact-icon">
                        <Phone size={16} />
                      </div>
                      <div className="idlbayfooter-contact-details ms-2">
                        <span className="idlbayfooter-contact-value">
                          +91 9840 841 840
                        </span>
                      </div>
                    </div>
                    
                    <div 
                      className="idlbayfooter-contact-item d-flex align-items-center mt-2"
                      onClick={handleEmailClick}
                    >
                      <div className="idlbayfooter-contact-icon">
                        <Mail size={16} />
                      </div>
                      <div className="idlbayfooter-contact-details ms-2">
                        <span className="idlbayfooter-contact-value">
                          contact@idlbay.com
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Social Media Links */}
                  <div className="idlbayfooter-social-links">
                    <a href="https://www.linkedin.com/company/idlbay" className="idlbayfooter-social-link" aria-label="LinkedIn">
                      <Linkedin size={18} />
                    </a>
                     <a href="https://www.instagram.com/idlbay.official/" className="idlbayfooter-social-link" aria-label="Instagram">
                      <Instagram size={18} />
                    </a>
                      {/* <a 
                      href={`https://wa.me/919840841840?text=${encodeURIComponent(whatsappMessage)}`}
                      className="idlbayfooter-social-link" 
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Contact us on WhatsApp"
                      onClick={handleWhatsAppClick}
                    >
                      <FaWhatsapp size={18} />
                    </a> */}
                     <a href="https://x.com/idlbayPvtLtd" className="idlbayfooter-social-link" aria-label="X (formerly Twitter)">
                      <FaXTwitter size={18} />
                    </a>
                    <a href="https://www.facebook.com/profile.php?id=61582746578911" className="idlbayfooter-social-link" aria-label="Facebook">
                      <Facebook size={18} />
                    </a>
                     <a href="https://www.youtube.com/channel/UCDSb9__-mSLqeyuZYelakcw" className="idlbayfooter-social-link" aria-label="youtube">
                      <Youtube size={18} />
                    </a>
                    
                   
                  
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Corporate Address */}
          <div className="row mt-4">
            <div className="col-12">
              <div className="idlbayfooter-address-container">
                <span className="idlbayfooter-address-label">Corporate Office :</span>
                <div className="idlbayfooter-address-content">
                  <span className="idlbayfooter-address-text">
                    Office No.1, First Floor, Door No.1, B Narasimhan 3rd Street, T-Nagar, Chennai, Tamil Nadu 600017
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="idlbayfooter-bottom idlbayfooter-section mt-4">
            <div className="row align-items-center">
              <div className="col-md-6 col-12">
                <p className="idlbayfooter-copyright">
                  © 2025 IDLBAY Private Limited. All rights reserved.
                </p>
              </div>
              <div className="col-md-6 col-12">
                <div className="idlbayfooter-bottom-links">
                  <Link to="/privacypolicy" className="idlbayfooter-bottom-link">Privacy Policy</Link>
                  <Link to="/terms" className="idlbayfooter-bottom-link">Terms of Service</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;